<template>
    <div class="subject-container">
        <div class="common-subject" v-if="this.name !== 'xcb'">
            <img :src="bg" class="common-bg" alt />
            <div class="subject-top">
                <div class="bjx-top">
                    <div class="subject-title">
                        <img :src="title" class="common-bg" alt />
                    </div>
                    <canvas class="subject-canvas" id="xCanvas"></canvas>
                    <div class="subject-bottom">
                        <img :src="text" class="bjx-text" alt />
                        <a
                            href="javascript:;"
                            @click="goToDetails"
                            class="bjx-button s-common-button"
                        ></a>
                        <img
                            :src="back"
                            @click="goBack"
                            class="s-back-button"
                            alt
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="common-subject">
            <xcb></xcb>
        </div>
    </div>
</template>
<script>
import Loader from "@/utils/resourceLoader.js";
import Director from "@/entry/director";
import { DataStore } from "@/entry/base/DataStore.js";
import xcb from "./details/xcb";
export default {
    data() {
        return {
            title: "",
            text: "",
            bg: "",
            back: "",
        
        };
    },
    props: {
        name: String,
    },
    components: {
        xcb,
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.name !== "xcb") {
                this.title = this.$store.state.subject[this.name].title;
                this.text = this.$store.state.subject[this.name].text;
                this.bg = this.$store.state.subject[this.name].bg;
                this.back = this.$store.state.subject[this.name].back;
                this.createAnimate();
            }
            
        },
        createAnimate() {
            let dataStore, director; //总资源
            let length = this.name == "bjx" ? 12 : 24;
            let isLoader = this.$store.state.isLoader[this.name];

            Loader.create(
                (load, resources, app) => {
                    dataStore = DataStore.getInstance();
                    dataStore[`${this.name}_resources`] = resources;
                    dataStore[`${this.name}_app`] = app;
                    director = new Director(this.name, length);
                    director.initScene();
                },
                this.name,
                isLoader
            );
            this.$store.dispatch("saveLoaderStatus", {
                type: this.name,
                value: true,
            });
        },
        goBack() {
            this.$router.push("/credit");
        },
        goToDetails() {
            this.goToRoute({ path: "Subject", name: this.name });
        },
        goToRoute(path) {
            if (typeof path === "string") {
                this.$router.push(path);
            } else {
                this.$router.push({
                    name: path.path,
                    params: { name: path.name },
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>